module.exports = __webpack_public_path__ + "img/cable-internet.50e78267.png";